import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['form', 'editable', 'edit', 'submit', 'cancel'];

  connect() {
    this.editing = false;

    this.editableTargets.forEach(cell => {
      const template = cell.querySelector('template');

      if (template) {
        cell.editContent = template.innerHTML;
        template.remove();
        cell.showContent = cell.innerHTML;
      }
    })
  }

  toggle(event) {
    this.editing = !this.editing;

    if (this.editing) {
      this.editableTargets.forEach(cell => {
        cell.showContent = cell.innerHTML;
        cell.innerHTML = cell.editContent;
      })

      this.editTarget.style.display = 'none';
      this.submitTarget.style.display = '';
      this.cancelTarget.style.display = '';
    }
    else {
      this.editableTargets.forEach(cell => {
        cell.editContent = cell.innerHTML;
        cell.innerHTML = cell.showContent;
      })

      this.editTarget.style.display = '';
      this.submitTarget.style.display = 'none';
      this.cancelTarget.style.display = 'none';
    }

    event.preventDefault();
  }

  submit(event) {
    event.preventDefault();
    
    this.formTarget.submit();
  }
}
